<template src="@/templates/dhs/manualModel.html"></template>

<script>
	import ManualReportModel from '@/models/manualReportModel'

	export default {
		name: "ManualModel",
		props: ['modelData'],
		data() {
			return {
				manualReportModel: new ManualReportModel(),
				manualModel: {},
				customClass: {
					emptyClass: '',
					reliefClass: '',
					trClass: ''
				}
			}
		},
		created() {
			console.log(this.manualModel);
			this.manualModel = this.modelData;
		},
		methods: {
			getManualReport(manualReport) {
				let url = this.manualReportModel.getRoute('fetch') + manualReport.client_manual_report_id;

				this.$http.get(url, {
					headers: {"Bearer": localStorage.getItem("jwt")},
					responseType: 'arraybuffer'
				}).then((res) => {

					let file = res.data;
					this.forceFileDownload(file, manualReport);

				}).catch(function (error) {
					console.log(error);
				});
			},
			forceFileDownload(file, manualReport){

				// It is necessary to create a new blob object with mime-type explicitly set
				// otherwise only Chrome works like it should
				let newBlob = new Blob([file], {type: manualReport.mime_type});

				// IE doesn't allow using a blob object directly as link href
				// instead it is necessary to use msSaveOrOpenBlob
				if (window.navigator && window.navigator.msSaveOrOpenBlob) {
					window.navigator.msSaveOrOpenBlob(newBlob);
					return;
				}

				// For other browsers:
				// Create a link pointing to the ObjectURL containing the blob.
				const data = window.URL.createObjectURL(newBlob);
				var link = document.createElement('a');
				link.href = data;
				link.download = (manualReport.title == null || manualReport.title === '') ? 'No File Title' : manualReport.title + '.' + manualReport.ext;
				link.click();
				
				let url = window.URL;
				setTimeout(function(){
					// For Firefox it is necessary to delay revoking the ObjectURL
					url.revokeObjectURL(data.href);
				}, 100);
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/dhs/ManualModel.vue